import { render, staticRenderFns } from "./GenerateScreenshotDialog.vue?vue&type=template&id=205d2b19&"
import script from "./GenerateScreenshotDialog.vue?vue&type=script&lang=ts&"
export * from "./GenerateScreenshotDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports